export default "__VITE_ASSET__BJ$3yT2K__"